/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ClientPermissionResponse,
  ClientResponse,
  CreateOrUpdateClientPermissionRequest,
} from '../dto'
import { ContentType, HttpClient, RequestParams } from './http-client'

export class ClientController<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags client-controller
   * @name CreateOrUpdateClientPermission
   * @request PUT:/api/v1/accounting-client/permissions/{type}
   */
  createOrUpdateClientPermission = (
    type: string,
    data: CreateOrUpdateClientPermissionRequest,
    params: RequestParams = {},
  ) =>
    this.http.request<ClientPermissionResponse, any>({
      path: `/v1/accounting-client/permissions/${type}`,
      method: 'PUT',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    })

  static createOrUpdateClientPermissionPath = '/v1/accounting-client/permissions/${type}'
  static createOrUpdateClientPermissionMethod = 'PUT'
  /**
   * No description
   *
   * @tags client-controller
   * @name FindClientByClientOrganisationId
   * @request GET:/api/v1/accounting-client
   */
  findClientByClientOrganisationId = (params: RequestParams = {}) =>
    this.http.request<ClientResponse, any>({
      path: `/v1/accounting-client`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findClientByClientOrganisationIdPath = '/v1/accounting-client'
  static findClientByClientOrganisationIdMethod = 'GET'
}
